// ログイン失敗(admin.login)
export class AdminLoginFailed extends Error {}

// ログイン失敗
export class LoginFailed extends Error {}
